import * as _ from 'lodash';
import Axios from 'axios';
import { PartSelection } from '@/components/families/ori/Ori9';

type Constructor<T = {}> = new (...args: any[]) => T;

export type When = string;

abstract class AttributesBase {
  readonly [key: string]: any;

  public as<T>(): T {
    return (<T>(this as any));
  }
}

abstract class DefaultSelectionBase {
  readonly [key: string]: any;

  public as<T>(): T {
    return (<T>(this as any));
  }

  public value<T>(key:string): T {
    return (<T>(this[key]));
  }
}



export class DefaultSelection extends DefaultSelectionBase {
  readonly parts?: PartSelection[];

  constructor(seletcion: any) {
    super();
    Object.assign(this, seletcion);
  }
}

export class ProductAttributes extends AttributesBase {
  readonly title?: string;
  readonly image?: string;

  constructor(attributes: any) {
    super();
    Object.assign(this, attributes);
  }
}


export class PartsPalette {
  public readonly order: number;
  public readonly part: string;
  public readonly materials: string[];
  public colorPalettes: string[];
}

export class FamilyDimensions {

  constructor(public readonly title: string, public readonly image: string, public readonly values: { [key: string]: any }) {

  }
}

export class FamilyDefinition {
  public readonly id: string;
  public readonly name: string;
  public readonly sketchfabModelId: string;
  public readonly desc: string;
  private readonly _products: ProductDefinition[] = [];
  private readonly _dimensions: FamilyDimensions[] = [];

  constructor(id: string, name:string, sketchfabModelId: string,desc: string) {
    this.id = id;
    this.name = name;
    this.desc = desc;
    this.sketchfabModelId = sketchfabModelId;
  }
  public get products(): ReadonlyArray<ProductDefinition> {
    return this._products;
  }

  public get dimensions(): ReadonlyArray<FamilyDimensions> {
    return this._dimensions;
  }

  public static parse(obj: any, allAnimations: AnimationDefinition[]): FamilyDefinition {
    const pd = new FamilyDefinition(obj.id, obj.name, obj.sketchfabModelId,obj.desc);
    _.each(obj.products, (p) => {
      pd._products.push(ProductDefinition.parse(p, allAnimations));
    });
    _.each(obj.dimensions, (d) => {
      pd._dimensions.push(new FamilyDimensions(d.title, d.image, d.values));
    });

    return pd;
  }

}

export interface IPalette {
  name: string;
  type: string;
  defaultColor: string;
  id: string;
  description: string;
  colors: IPaletteColor[];
}

export interface IPaletteColor {
  texture: string;
  name: string;
  displayName: string;
}


export class ProductDefinition {

  public readonly id: string;
  public readonly name: string;
  public readonly attributes?: ProductAttributes;
  public readonly defaults: DefaultSelection;
  public readonly companentName: string;
  public readonly initialCommands: any;
  public  partsPalettes: PartsPalette[] = [];
  private _animations: AnimationDefinition[] = [];

  constructor(id: string, name: string, attributes: ProductAttributes, companentName: string, initialCommands: any, defaults: DefaultSelection, partsPalettes: PartsPalette[]) {
    this.id = id;
    this.name = name;
    this.defaults = defaults;
    this.attributes = attributes;
    this.companentName = companentName;
    this.initialCommands = initialCommands;
    this.partsPalettes = partsPalettes;
  }

  public get animations(): ReadonlyArray<AnimationDefinition> {

    return this._animations;
  }

  public static parse(obj: any, allAnimations: AnimationDefinition[] = []): ProductDefinition {
    const pd = new ProductDefinition(obj.id, obj.name, new ProductAttributes(obj.attributes), obj.companentName, obj.initialCommands, new DefaultSelection(obj.default), obj.partsPalettes);

    pd._animations = _.filter(allAnimations, an => _.includes(an.models,pd.id));


    return pd;
  }
}

export class ConfiguratorDefinition {
  private readonly _families: FamilyDefinition[] = [];
  private _palettes: IPalette[] = [];
  private _allAnimations: AnimationDefinition[] = [];


  public get families(): ReadonlyArray<FamilyDefinition> {
    return this._families;
  }

  public get palettes(): ReadonlyArray<IPalette> {
    return this._palettes;
  }

  public get animations(): ReadonlyArray<AnimationDefinition> {
    return this._allAnimations;
  }

  constructor() {

  }

  public static parse(obj: any): ConfiguratorDefinition {
    const cd = new ConfiguratorDefinition();
    _.each(obj.animations,(an) => {
      cd._allAnimations.push(AnimationDefinition.parse(an));
    });

    _.each(obj.families, (p) => {
      cd._families.push(FamilyDefinition.parse(p, obj.animations));
    });
    cd._palettes = obj.palettes as IPalette[];
    return cd;
  }
}

export function parse(obj: any): ConfiguratorDefinition {
  if (!obj) {
    return null;
  }

  return ConfiguratorDefinition.parse(obj as any);
}


export class AnimationDefinition {
  public readonly order: number;
  public readonly annotationIndex: number;
  public readonly runCount: number;
  public readonly animationName: string;
  public readonly name: string;
  public readonly content: string;
  public readonly commands: any;
  public readonly models: string[];

  public readonly attributes : {
    readonly [key: string]: any;
  };
  public isDisable: boolean = false;

  constructor(order: number,models:string[], annotationIndex: number, runCount: number, animationName: string, name: string, content: string, commands: any,attributes:any) {
    this.order = order;
    this.annotationIndex = annotationIndex;
    this.runCount = runCount;
    this.name = name;
    this.animationName = animationName;
    this.content = content;
    this.commands = commands;
    this.isDisable = false;
  }


  public static parse(obj: any): AnimationDefinition {
    const pd = new AnimationDefinition(obj.order,obj.models, obj.annotationIndex, obj.runCount, obj.animationName, obj.name, obj.content, obj.commands, obj.attributes);

    return pd;
  }

}





// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/models/configuratorx/configuratorSchema.ts